// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"07662c5c","977":"d74b37c1"}[chunkId] + ".chunk.js";
};